<button class="c-button" [ngClass]="{'is-secondary': !primary, 'is-disabled': primary && disabled}"
  [disabled]="disabled">
  <ng-content></ng-content>
</button>
